// extracted by mini-css-extract-plugin
export default {"form":"Form_form__-ivML","submitted":"Form_submitted__lGRoU"};